import script from "./ContractsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractsTable.vue?vue&type=script&setup=true&lang=js"

import "./ContractsTable.vue?vue&type=style&index=0&id=7b482926&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b482926"]])

export default __exports__